import {useEffect, useState} from 'react';

export function useScrollableArrows(ref, deps = []) {
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const update = () => {
      setShowLeft(el.scrollLeft > 0);
      setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };

    update();
    el.addEventListener('scroll', update);
    window.addEventListener('resize', update);

    return () => {
      el.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, deps);

  const scrollByAmount = d => {
    ref.current?.scrollBy({left: d, behavior: 'smooth'});
  };

  return {
    showLeft,
    showRight,
    scrollLeft: () => scrollByAmount(-120),
    scrollRight: () => scrollByAmount(120)
  };
}
